import { useState } from "react";
import { Euro } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { eur } from "@/lib/api";

const DISCOUNTS = [5, 10, 15, 20];

export function OfferPicker({ price, onSend, busy }) {
  const [custom, setCustom] = useState("");
  const amount = (pct) => Math.round(price * (1 - pct / 100) * 100) / 100;
  return (
    <div className="space-y-2" data-testid="offer-picker">
      <p className="text-xs text-stone-500">Prix demandé : {eur(price)} — proposez :</p>
      <div className="flex flex-wrap gap-2">
        {DISCOUNTS.map((p) => (
          <button key={p} type="button" disabled={busy} data-testid={`offer-quick-${p}`} onClick={() => onSend(amount(p))}
            className="rounded-full border border-forest/30 bg-white px-3 py-1.5 text-sm hover:bg-forest hover:text-white transition-colors">
            −{p} % · <b>{eur(amount(p))}</b>
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        <Input data-testid="offer-input" type="number" value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="Autre montant (€)" className="bg-white w-44" />
        <Button data-testid="offer-send-btn" variant="outline" disabled={!custom || busy} onClick={() => { onSend(Number(custom)); setCustom(""); }} className="rounded-full">
          <Euro className="w-4 h-4 mr-1" />Proposer{custom && price ? ` (−${Math.max(0, Math.round((1 - custom / price) * 100))} %)` : ""}
        </Button>
      </div>
    </div>
  );
}
